<template>
  <div class="details">
    <Header />
    <div class="bg">
      <div class="title">
        <span class="zn">机构动态</span>
        <span class="en">Agency dynamics</span>
        <span class="line"></span>
        <span>众信动态</span>
      </div>
    </div>
    <div class="content">
      <div class="backpage-header">
        <el-button type="text" @click="goBackDynamicsList"><i class="el-icon-back"></i> 返回动态列表</el-button>
      </div>
      <h2>{{InfoReleaseModel.Title}}</h2>
      <div class="from">来源：{{InfoReleaseModel.InfoSource}} 日期： {{InfoReleaseModel.CreateTime}}</div>
      <div class="text" v-html="InfoReleaseModel.InfoContent"></div>
      <!-- //暂时不上的功能 
        <div class="href clearfix">
        <el-link
          href="https://www.ebs.org.cn/EbsNews/Detail/06e82902-60c2-4021-be55-14eac23af02a"
          target="_blank"
          class="left"
        >
          <i class="el-icon-caret-left"></i>上一篇：无
        </el-link>
        <el-link
          href="https://www.ebs.org.cn/EbsNews/Detail/8cfa4cb7-7b21-410c-9df6-dc1fcac219a2"
          target="_blank"
          class="right"
        >
          <i class="el-icon-caret-right"></i>下一篇：网监处多措并举精准助力防疫物资企业触网转···
        </el-link>
      </div>-->
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from './components/Header'
import Footer from './components/Footer'
import { GetInfoReleaseById } from './utils/http'
export default {
  name: 'DynamicsDetails',
  components: { Header, Footer },
  data() {
    return {
      newsId: '',
      InfoReleaseModel: {},
      currentPage: 1
    }
  },
  created() {
    const { currentPage, newsId } = this.$route.params
    this.currentPage = currentPage
    this.newsId = newsId
    this.GetInfoReleaseById()
  },
  methods: {
    GetInfoReleaseById() {
      GetInfoReleaseById(this.newsId).then(res => {
        const { status, data } = res
        if (status == 200) {
          this.InfoReleaseModel = data.InfoReleaseModel
        }
      }).catch(err => { console.log(err) })
    },
    goBackDynamicsList() {
      this.$router.push({ name: 'InstitutionalDynamics', params: { type: 1, currentPage: this.currentPage } })
    }
  }
}
</script>
<style lang="less" scoped>
.details {
  .bg {
    width: 100%;
    height: 200px;
    margin-top: 60px;
    background: url(./assets/images/banner/banner2.png) no-repeat;
    .title {
      width: 1040px;
      margin: 0 auto;
      padding-top: 80px;
      span {
        color: #2d313d;
        &.zn {
          font-size: 24px;
          font-weight: bold;
          margin-right: 20px;
        }
        &.en {
          font-size: 24px;
        }
        &.line {
          display: block;
          width: 22px;
          height: 8px;
          margin: 13px 0 20px;
          background-color: #d0211f;
        }
      }
    }
  }
  .content {
    width: 1040px;
    margin: 20px auto 60px;
    h2 {
      color: #000;
      font-size: 24px;
      font-weight: bold;
      margin-top: 60px;
      text-align: center;
    }
    .from {
      margin: 20px auto;
      font-size: 14px;
      color: #999;
      padding-bottom: 20px;
      border-bottom: 1px solid #eee;
      text-align: center;
    }
    .text {
      text-indent: 2em;
      color: #666;
      font-size: 16px;
      line-height: 30px;
    }
    .href {
      margin: 120px auto;
      border-top: 1px solid #eee;
      padding-top: 28px;
      line-height: 24px;
      i {
        color: #df3d3c;
        font-size: 22px;
        vertical-align: top;
      }
      .left {
        float: left;
      }
      .right {
        float: right;
      }
    }
  }
}
</style>